import {
  DEMO_BEFORE_CLASS,
  DEMO_CONTROLS_CLASS,
  WIDGET_CLASS
} from '../constants';

const DEMO_CLASSES = [DEMO_BEFORE_CLASS, DEMO_CONTROLS_CLASS];

export function createExcludedSelectors() {
  const selectors = [
    `[class*="${WIDGET_CLASS}"]`,
    `[class*="${WIDGET_CLASS}"] *`,
    ...DEMO_CLASSES.flatMap((className) => [`.${className}`, `.${className} *`])
  ];

  selectors.push('i', 'i *');

  return selectors.join(', ');
}

export function createBodyNotExcludedSelector() {
  return `body *:where(:not(${createExcludedSelectors()}))`;
}

export function createPreviewBodyNotExcludedSelector() {
  const demoContainersSelector = DEMO_CLASSES.map(
    (className) => `.${className}`
  ).join(', ');

  return `${createBodyNotExcludedSelector()}:not(:has(${demoContainersSelector}))`;
}
